import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

import { RESET_FOCUS_AREA_ID } from '../constants';

@Injectable()
export class FocusService {
  readonly #document = inject(DOCUMENT);

  /**
   * This will reset the users focus back to the beginning of the page.
   * After calling this, the next TAB from the user will trigger the <wl-skip-links> items.
   */
  resetFocus() {
    this.#document.getElementById(RESET_FOCUS_AREA_ID)?.focus();
  }
}
